import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { IoCloseCircleOutline } from 'react-icons/io5';
import styles from './HomePopup.module.scss';

// const API_URL = 'http://localhost/tramhuong/api/admin/popup_crud.php';
// const BACKEND_URL = 'http://localhost/tramhuong';
const API_URL = 'https://huongtramcomoc.vn/api/admin/popup_crud.php';
const BACKEND_URL = 'https://huongtramcomoc.vn';

const HomePopup = () => {
  const [activePopup, setActivePopup] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasClosed = sessionStorage.getItem('popup_closed_session');
    if (hasClosed) return;

    axios.get(API_URL).then(res => {
      // Lọc lấy các popup đang bật (is_active == 1)
      const activeList = res.data.filter(p => p.is_active == 1 && p.image_url);
      
      if (activeList.length > 0) {
        // Lấy cái MỚI NHẤT (đầu tiên trong mảng vì SQL order by DESC)
        // Hoặc bạn có thể Random: activeList[Math.floor(Math.random() * activeList.length)]
        setActivePopup(activeList[0]);
        setTimeout(() => setIsVisible(true), 1000);
      }
    });
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem('popup_closed_session', 'true'); 
  };

  if (!isVisible || !activePopup) return null;

  return (
    <div className={styles.overlay}>
      <div 
        className={styles.popupContent} 
        style={{ maxWidth: `${activePopup.max_width}px` }} // <-- ÁP DỤNG ĐỘ RỘNG TÙY CHỈNH
      >
        <button className={styles.closeBtn} onClick={handleClose}>
          <IoCloseCircleOutline />
        </button>
        
        {activePopup.link_url ? (
          <Link to={activePopup.link_url} onClick={handleClose}>
            <img src={`${BACKEND_URL}${activePopup.image_url}`} alt="Popup" />
          </Link>
        ) : (
          <img src={`${BACKEND_URL}${activePopup.image_url}`} alt="Popup" />
        )}
      </div>
    </div>
  );
};

export default HomePopup;